import React, { Component } from "react";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  HelpBlock,
  Alert,
  Link,
  Tooltip,
  OverlayTrigger,
  Modal,
  ListGroup,
  ListGroupItem
} from "react-bootstrap";
import { render } from "react-dom";
import {
  SortableContainer,
  SortableElement,
  arrayMove
} from "react-sortable-hoc";
import SortableItem from "./SortableItem";

class List extends Component {
  constructor(props) {
    super(props);
    this.handleRemove = this.handleRemove.bind(this);
  }
  handleRemove = index => {
    this.props.handleDelete(index);
  };

  render() {
    const { items } = this.props;

    return (
      <ListGroup>
        {items.map((value, index) => (
          <SortableItem
            key={`item-${index}`}
            index={index}
            handleRemove={this.handleRemove}
            sortIndex={index}
            value={value}
          />
        ))}
      </ListGroup>
    );
  }
}

const SortableList = SortableContainer(List, { withRef: true });
export default SortableList;



// WEBPACK FOOTER //
// ./src/app/views/admin/EmailManager/multi/SortableList.js